const MetricCard = ({ label, value, sub, accent, testid, icon: Icon, delta }) => {
  const showDelta = delta !== undefined && delta !== null && !Number.isNaN(delta);
  const positive = showDelta && delta > 0;
  const negative = showDelta && delta < 0;
  return (
    <div
      className="bg-white border border-[#E4DFD2] rounded-xl p-5 hover:border-[#D6CFB9] transition-colors"
      data-testid={testid}
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] tracking-[0.08em] uppercase font-semibold text-[#69747C]">
          {label}
        </div>
        {Icon ? <Icon className="w-4 h-4 text-[#C9C2B0]" /> : null}
      </div>
      <div className="flex items-baseline gap-2 mt-3">
        <div
          className={`font-display text-3xl font-semibold tracking-tight ${
            accent || "text-[#1F2326]"
          }`}
        >
          {value}
        </div>
        {showDelta ? (
          <div
            data-testid={`${testid}-delta`}
            className={`text-xs font-semibold tabular-nums px-1.5 py-0.5 rounded ${
              positive
                ? "bg-[#EFF3EE] text-[#42624B]"
                : negative
                ? "bg-[#FAEEED] text-[#7E332D]"
                : "bg-[#F3EFE3] text-[#69747C]"
            }`}
            title="vs. last saved snapshot"
          >
            {positive ? "▲" : negative ? "▼" : "·"}
            {Math.abs(delta).toFixed(1)}%
          </div>
        ) : null}
      </div>
      {sub ? <div className="text-xs text-[#69747C] mt-1">{sub}</div> : null}
    </div>
  );
};

export default MetricCard;
